import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import DateFormatter from "helper/dateFormartter";
import { styled } from '@mui/material/styles';
import { width } from "@mui/system";

const formatNumber = (value) => {
  return typeof value === "number" ? value.toFixed(2) : "0.00";
};

const STableCell = styled(TableCell)(({ theme }) => ({
  fontFamily: 'Roboto, sans-serif',
  fontWeight: 500,
  fontSize: '0.875rem',
  lineHeight: 1.43,
  display: 'table-cell',
  verticalAlign: 'inherit',
  borderBottom: '1px solid rgba(224, 224, 224, 1)',
  textAlign: 'left',
  padding: '6px 16px',
  color: 'rgba(0, 0, 0, 0.87)',
  minWidth: '250px',
}));

export default function ProductTable(props) {
  const {rows} = props;

  function mappingValue(invoice, field, mapping, newField) {
    if (field in invoice) {
      const dataField = invoice[field];
      const matchingDescription = mapping.find(
        (item) => {

        if(item.Description === dataField){
          return item
        }
        }
      );
      if (matchingDescription) {
        const code = matchingDescription.Code;
        invoice[newField] = code;
      }
    }
  }
  

  const dateFormatter = DateFormatter();

  return (
    <TableContainer
      component={Paper}
      sx={{
        border: "1px solid black",
        marginLeft: "auto",
        marginRight: "auto",
      }}
    >
      <Table sx={{ minWidth: 650 }} size="small">
        <TableHead>
          <TableRow>
            {/* <TableCell>Ref. Number</TableCell> */}
            <STableCell>Classification</STableCell>
            <TableCell sx={{ width: 300 }}>Descriptions</TableCell>
            <TableCell>Discount Amount&nbsp;(RM)</TableCell>
            <TableCell>Discount Rate&nbsp;(%)</TableCell>
            <TableCell>Measure</TableCell>
            <TableCell>Unit Price</TableCell>
            <TableCell>Charge Amount</TableCell>
            <TableCell>Charge Rate</TableCell>
            <TableCell>Discount Amount</TableCell>
            <TableCell>Discount Rate</TableCell>
            <TableCell>Country</TableCell>
            <TableCell>Quantity</TableCell>
            <TableCell>Tariff Code</TableCell>
            <TableCell>Tax Amount</TableCell>
            <TableCell>Tax Rate</TableCell>
            <TableCell>Tax Type</TableCell>
            <TableCell>Tax Exemption Amount</TableCell>
            <STableCell>Tax Exemption Description</STableCell>
            <TableCell>Total Exclude Tax</TableCell>
            <TableCell>Total Amount</TableCell>
            <TableCell>Unit Price</TableCell>
          </TableRow>
        </TableHead>
        {rows.length === 0 ? (
          <TableRow>
            <TableCell colSpan={12}>
              <Typography textAlign="center" color="lightgray">
                No Data Available
              </Typography>
            </TableCell>
          </TableRow>
        ) : (
          <TableBody>
            {rows.map((row, i) => (
              <TableRow
                key={i}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell>{row.classId}-{row.classdesc}</TableCell>
                <TableCell>{row.lineDesc}</TableCell>
                <TableCell>{formatNumber(row.discAmt)}</TableCell>
                <TableCell>{formatNumber(row.discRate)}</TableCell>
                <TableCell>{row.uom}</TableCell>
                <TableCell>{formatNumber(row.unitPrice)}</TableCell>
                <TableCell>{formatNumber(row.chargeAmt)}</TableCell>
                <TableCell>{formatNumber(row.chargeRate)}</TableCell>
                <TableCell>{formatNumber(row.discAmt)}</TableCell>
                <TableCell>{formatNumber(row.discRate)}</TableCell>
                <TableCell>{row.originCountry}</TableCell>
                <TableCell>{row.qty}</TableCell>
                <TableCell>{formatNumber(row.tariffCode)}</TableCell>
                <TableCell>{formatNumber(row.taxAmt)}</TableCell>
                <TableCell>{formatNumber(row.taxRate)}</TableCell>
                <TableCell>{`${row.taxTypeId}`.padStart(2, '0')}</TableCell>
                <TableCell>{formatNumber(row.taxExemptAmt)}</TableCell>
                <TableCell>{row.tax_ExemptionDesc}</TableCell>
                <TableCell>{formatNumber(row.total_ExcludeTax)}</TableCell>
                <TableCell>{formatNumber(row.total_LineAmt)}</TableCell>
                <TableCell>{formatNumber(row.unitPrice)}</TableCell>
              </TableRow>
            ))}
            {/* {emptyRows > 0 && (
              <TableRow>
                <TableCell colSpan={11} />
              </TableRow>
            )} */}
          </TableBody>
        )}
      </Table>
    </TableContainer>
  );
}
